import React, { Component } from 'react'
import { Dropdown, } from 'react-bootstrap'
import { connect } from 'react-redux'
import { fetchEwGroups, selectEwGroup } from '../action/ewGroupActions'

class RoleGroup extends Component {

  constructor(props) {
    super(props)
    this.state = { selected: null }
  }


  render() {
    console.log('dbGroup', this.props.dbGroup)
    console.log('selected', this.props.selectEwGroup)
    if (this.props.dbGroup && !this.props.selected) {
      let selected = this.props.groups.find((g) => { return g.name === this.props.dbGroup })

      if (this.props.serviceAccount)
        selected = this.props.groups[0]

      // this.state.selected = selected
      console.log('about to select group', selected)
      if (selected) {
        this.props.dispatch(selectEwGroup(selected, this.props.index))
      }

    }

    return (
      <div>
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            {this.props.selected && this.props.selected.name ? this.props.selected.name : 'Select a Group'}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Header>Roles</Dropdown.Header>
            {this.props.groups.map((g, index) => {
              return <Dropdown.Item onSelect={() => {
                //  this.setState({selected : g})

                this.props.dispatch(selectEwGroup(g, this.props.index))

              }} key={g.name} >{g.name}</Dropdown.Item>
            })}
          </Dropdown.Menu>


        </Dropdown>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => (
  {
    groups: state.acct.ewGroup['groupCo' + ownProps.index] || [],
    mfrError: state.acct.ewGroup.error,
    selected: state.acct.ewGroup['selected' + ownProps.index]
  });



export default connect(mapStateToProps, null, null, { forwardRef: true })(RoleGroup)